import modules from '../../../modules.json'

const stripTrailingSlash = (path: string): string =>
  path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path

type TUrlEnvironment = {
  [key: string]: string
}

export const parsedModules = modules.map(module => {
  const typeUrls: TUrlEnvironment = {
    local: 'url_local',
    staging: 'url_staging',
    production: 'url_production',
  }

  const urlKey = typeUrls[process.env.REACT_APP_ENV || '']

  return { ...module, url: `${stripTrailingSlash(module[urlKey as never] || '')}` }
})
